import { Sites } from '@ps/platform-message-framework/common/Sites';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch, RootState } from '../store';
import { select } from '../store';
import type { SpinOfDayData } from '../types/CasinoBonus';

import { useBonusGameQuery } from './useBonusGameQuery';
import useEmbeddedAPI from './useEmbeddedAPI';

const useCasinoBonusGame = (
  launchCallback?: () => void
): React.Dispatch<React.SetStateAction<SpinOfDayData | undefined>> => {
  const [game, setGame] = useState<SpinOfDayData>();
  const dispatch = useDispatch<Dispatch>();
  const site = useSelector(select.cms.getSiteId);
  const tncVersion = useSelector(select.casino.sotdLatestVersion);
  const areTermsAccepted = useSelector((state: RootState) =>
    select.casino.acceptedSotdTermsAreCurrent(state, tncVersion)
  );
  const showTerms = site === Sites.UK && !areTermsAccepted;
  const query = useBonusGameQuery(game);
  const launch = useCallback(() => {
    dispatch.modal.enqueue({
      path: '/casino/game-overlay',
      locationState: { gameUrl: game?.gameURL, query, title: 'CasinoBonusGame' }
    });
  }, [dispatch, game, query]);
  const termsOpen = useCallback(
    () =>
      dispatch.modal.unshift({
        path: '/casino/help',
        locationState: {
          isSotd: true,
          acceptanceRequired: true,
          version: tncVersion
        }
      }),
    [dispatch, tncVersion]
  );

  useEmbeddedAPI();

  useEffect(() => {
    if (!game) return;
    if (showTerms) {
      termsOpen();
    } else {
      launchCallback ? launchCallback() : launch();
    }
    setGame(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [game, showTerms, tncVersion]);

  return setGame;
};

export default useCasinoBonusGame;
